import { makeStyles } from "@material-ui/core";

const styles = makeStyles((theme) => ({
  root: {
    width: "calc(100% - 32px)",
    height: 64,
    marginLeft: 32,
    marginBottom: theme.hv.spacing.xs,
  },
  urlInputContainer: {
    display: "flex",
    alignItems: "baseline",
    overflow: "visible",

    "& > *": {
      marginLeft: theme.hv.spacing.xs,
    },
    "& > *:first-child": {
      marginLeft: 0,
    },
  },
  urlInput: {
    flexGrow: 1,
  },
}));

export default styles;
